import { render, staticRenderFns } from "./main-search.vue?vue&type=template&id=3df44d7e"
import script from "./main-search.vue?vue&type=script&lang=js"
export * from "./main-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports